import type { IIconsButtonProps } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";

import { StyledExpandIconButton } from "./styles";

interface IExpandButtonProps extends IIconsButtonProps {
    tooltipText: string;
}

export const ExpandButton = (props: IExpandButtonProps) => {
    const { tooltipText, isDisabled = false, iconSize = "sm", type = "flat", ...buttonProps } = props;

    return (
        <PlainTooltip
            enabled={!isDisabled}
            tooltipContent={tooltipText}
        >
            <div>
                <StyledExpandIconButton
                    type={type}
                    iconSize={iconSize}
                    isDisabled={isDisabled}
                    dataAutomation="filters-panel.expand-toggle-button"
                    {...buttonProps}
                />
            </div>
        </PlainTooltip>
    );
};
